import {
  Button,
  Checkbox,
  DatePicker,
  Input,
  Radio,
  Select,
  Switch,
  InputNumber
} from "antd";
import { Option } from "antd/lib/mentions";
import React from "react";
import { Controller } from "react-hook-form";

const { RangePicker } = DatePicker;

const InputT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { value, onChange } }) => {
        return (
          <>
            <Input
              hidden={props.hidden || false}
              style={{ width: props.ancho }}
              value={value}
              placeholder={props.placeholder}
              onChange={(e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                onChange(e);
              }}
            />
          </>
        );
      }}
    />
  );
};
const TextAreaT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { value, onChange } }) => {
        return (
          <>
            <Input.TextArea
              style={{ width: props.ancho}}
              value={value}
              placeholder={props.placeholder}
              onChange={(e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                onChange(e);
              }}
            />
          </>
        );
      }}
    />
  );
};
const InputNumberT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { value, onChange } }) => {
        return (
          <>
            <InputNumber
              hidden={props.hidden || false}
              style={{ width: props.ancho }}
              value={value}
              min={props.min}
              max={props.max}
              placeholder={props.placeholder}
              onChange={(e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                onChange(e);
              }}
            />
          </>
        );
      }}
    />
  );
};
const CheckboxT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { value, onChange } }) => {
        return (
          <Checkbox
            hidden={props.hidden || false}
            checked={value}
            onChange={(e) => {
              if (props.onChange) {
                props.onChange(e);
              }
              onChange(e);
            }}
          />
        );
      }}
    />
  );
};
const SwitchT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { value, onChange } }) => {
        return (
          <Switch
            hidden={props.hidden || false}
            valuePropName="checked"
            checked={value}
            onChange={(e) => {
              if (props.onChange) {
                props.onChange(e);
              }
              onChange(e);
            }}
          />
        );
      }}
    />
  );
};
const RadioGroupT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { value, onChange } }) => {
        return (
          <Radio.Group
            value={value}
            onChange={(e) => {
              if (props.onChange) {
                props.onChange(e);
              }
              onChange(e);
            }}
          >
            {props.children}
          </Radio.Group>
        );
      }}
    />
  );
};
const RadioT = (props) => {
  return <Radio value={props.valor} hidden={props.hidden || false} />;
};

const SelectT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { value, onChange } }) => {
        return (
          <>
            <Select
              placeholder={props.placeholder} 
              style={{ width: props.ancho }}
              value={value}
              onChange={(e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                onChange(e);
              }}
              showSearch={props.showSearch || false}
              mode={props.mode}
            >
              {props.children}
            </Select>
          </>
        );
      }}
    />
  );
};
const OptionT = (props) => {
  return (
    <>
      <Option value={props.value} hidden={props.hidden || false}>{props.children}</Option>
    </>
  );
};
const DatePickerT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { onChange } }) => {
        return (
          <>
            <DatePicker
              onChange={(e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                onChange(e);
              }}
              picker={props.picker}
            />
          </>
        );
      }}
    />
  );
};
const RangePickerT = (props) => {
  return (
    <Controller
      {...props}
      render={({ field: { onChange } }) => {
        return (
          <>
            <RangePicker
              onChange={(e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                onChange(e);
              }}
            />
          </>
        );
      }}
    />
  );
};
const ButtonT = (props) => {
  return (
    <Button
      type={props.type}
      loading={props.loading}
      disabled={props.disabled}
      onClick={props.onClick}
      htmlType={props.htmlType}
      hidden={props.hidden || false}
      style={props.style}
    >
      {props.children}
    </Button>
  );
};

export {
  InputT,
  CheckboxT,
  SwitchT,
  RadioGroupT,
  RadioT,
  SelectT,
  OptionT,
  DatePickerT,
  RangePickerT,
  ButtonT,
  InputNumberT,
  TextAreaT
};
